import {css} from 'lit';

export default css`

.submenu-toggle {
  display: flex;
  float: right;
  flex-shrink: 0;
  width: 50px;
  margin-left: auto;
  padding-bottom: 1px;
  border: 0;
  border-bottom: 0.15rem solid #fff;
  appearance: none;
  background-color: #022851;
  text-align: center;
}
@media (min-width: 310px) {
  .submenu-toggle {
    width: 3rem;
  }
}
@media (min-width: 992px) {
  .submenu-toggle {
    display: none;
  }
  .submenu-toggle__icon {
    display: none;
  }
}
@media (min-width: 992px) {
  .submenu-toggle {
    display: flex;
  }
  .submenu-toggle__icon {
    display: block;
  }
}
.submenu-toggle:focus {
  box-shadow: inset 0 0 0 3px #022851;
  outline: none;
}
a:hover .submenu-toggle {
  background-color: #997300;
}
.submenu-toggle--open .submenu-toggle__icon:before {
  transform: rotate(0deg);
}
.submenu-toggle__wrapper {
  display: flex;
  align-items: stretch;
}
.submenu-toggle__wrapper a:first-child,
.submenu-toggle__wrapper .nolink:first-child {
  flex-grow: 1;
}
.submenu-toggle__icon {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  left: 30%;
  display: block;
  width: 40%;
  height: 3px;
  background-color: #fff;
  font-size: 0;
}
.submenu-toggle__icon:before {
  position: absolute;
  z-index: 1;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  content: "";
  transform: rotate(90deg);
  transition: all 0.3s;
}
a:hover .submenu-toggle__icon {
  background-color: #fff;
}
a:hover .submenu-toggle__icon:before {
  background-color: #fff;
}

`;